import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { FaWallet, FaEnvelope } from 'react-icons/fa';

const Footer = () => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate('/');
    window.scrollTo(0, 0);
  };

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <footer className="bg-gray-800 dark:bg-gray-950 text-white py-12 mt-16">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8 mb-8">
          
          {/* Sol - Logo ve Bilgi */}
          <div>
            <Link to="/" onClick={scrollToTop} className="flex items-center space-x-2 mb-4 hover:opacity-80 transition">
              <FaWallet className="text-primary-400 text-2xl" />
              <span className="text-xl font-bold">Döviz Defteri</span>
            </Link>
            <p className="text-gray-400 text-sm mb-4">
              Canlı döviz kurları ve altın fiyatlarını takip edin. Portföyünüzü yönetin, kazancınızı görün.
            </p>
            <div className="space-y-2 text-sm">
              <div className="flex items-center space-x-2 text-gray-400">
                <FaEnvelope />
                <span>kaanfurkankaya@gmail.com</span>
              </div>
            </div>
          </div>

          {/* Piyasalar */}
          <div>
            <h3 className="font-bold text-lg mb-4">Piyasalar</h3>
            <ul className="space-y-2 text-sm">
              <li>
                <Link to="/doviz" onClick={scrollToTop} className="text-gray-400 hover:text-primary-400 transition">
                  Döviz Kurları
                </Link>
              </li>
              <li>
                <Link to="/altin" onClick={scrollToTop} className="text-gray-400 hover:text-primary-400 transition">
                  Altın Fiyatları
                </Link>
              </li>
              <li>
                <Link to="/parite" onClick={scrollToTop} className="text-gray-400 hover:text-primary-400 transition">
                  Pariteler
                </Link>
              </li>
              <li>
                <Link to="/portfolio" onClick={scrollToTop} className="text-gray-400 hover:text-primary-400 transition">
                  Portföy Yönetimi
                </Link>
              </li>
            </ul>
          </div>

          {/* Hızlı Linkler */}
          <div>
            <h3 className="font-bold text-lg mb-4">Hızlı Linkler</h3>
            <ul className="space-y-2 text-sm">
              <li>
                <Link to="/" onClick={scrollToTop} className="text-gray-400 hover:text-primary-400 transition">
                  Ana Sayfa
                </Link>
              </li>
              {user ? (
                <>
                  <li>
                    <Link to="/portfolio" className="text-gray-400 hover:text-primary-400 transition">
                      Portföyüm
                    </Link>
                  </li>
                  <li>
                    <Link to="/add-asset" className="text-gray-400 hover:text-primary-400 transition">
                      Varlık Ekle
                    </Link>
                  </li>
                  <li>
                    <Link to="/settings" onClick={scrollToTop} className="text-gray-400 hover:text-primary-400 transition">
                      Ayarlar
                    </Link>
                  </li>
                  <li>
                    <button 
                      onClick={handleLogout}
                      className="text-gray-400 hover:text-primary-400 transition"
                    >
                      Çıkış Yap
                    </button>
                  </li>
                </>
              ) : (
                <>
                  <li>
                    <Link to="/login" className="text-gray-400 hover:text-primary-400 transition">
                      Giriş Yap
                    </Link>
                  </li>
                  <li>
                    <Link to="/register" className="text-gray-400 hover:text-primary-400 transition">
                      Kayıt Ol
                    </Link>
                  </li>
                </>
              )}
            </ul>
          </div>

          {/* Hakkımızda */}
          <div>
            <h3 className="font-bold text-lg mb-4">Bilgi</h3>
            <ul className="space-y-2 text-sm mb-4">
              <li>
                <Link to="/privacy" onClick={scrollToTop} className="text-gray-400 hover:text-primary-400 transition">
                  Gizlilik Politikası
                </Link>
              </li>
              <li>
                <span className="text-gray-400">KVKK Uyumlu</span>
              </li>
            </ul>
            <p className="text-gray-400 text-xs leading-relaxed">
              Döviz Defteri ile döviz ve altın yatırımlarınızı kolayca takip edin. 
              Gerçek zamanlı kur bilgileri ve detaylı portföy analizi.
            </p>
            <div className="mt-4">
              <p className="text-xs text-gray-500">
                © 2025 Döviz Defteri
              </p>
              <p className="text-xs text-gray-500 mt-1">
                Tüm hakları saklıdır.
              </p>
            </div>
          </div>
        </div>

        {/* Alt Çizgi ve Copyright */}
        <div className="border-t border-gray-700 pt-6 text-center">
          <p className="text-gray-400 text-sm">
            Veriler yalnızca bilgilendirme amaçlıdır. Yatırım kararlarınızı vermeden önce profesyonel destek almanızı öneririz.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;

